import { useState } from "react";
import { Link } from "react-router-dom";
import { LayoutDashboard, BadgeCheck, Building2, Inbox, GraduationCap, ListChecks, UserCheck, UserRound, MessageSquareText, Star, Coins, Gift, Package, Home, Image, Megaphone, MapPin, Users, Settings, Plug, FileSpreadsheet, ShieldCheck, Menu, X, LogOut, Search, Bell } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { BrandLogo } from "../BrandLogo";

const ICONS = { Overview: LayoutDashboard, Approvals: BadgeCheck, Institutions: Building2, Inquiries: Inbox, Students: GraduationCap, "Listed Students": ListChecks, "Listed Teachers": UserCheck, Teachers: UserRound, "Teacher Reviews": MessageSquareText, Reviews: Star, Points: Coins, Referrals: Gift, Packages: Package, Homepage: Home, Banners: Image, Broadcast: Megaphone, Locations: MapPin, Staff: Users, "Site Settings": Settings, Integrations: Plug, "Data (Excel)": FileSpreadsheet, Security: ShieldCheck };
const GROUPS = [
  ["Main", ["Overview", "Approvals", "Inquiries"]],
  ["People", ["Institutions", "Students", "Teachers", "Listed Students", "Listed Teachers"]],
  ["Quality", ["Reviews", "Teacher Reviews", "Points"]],
  ["Growth", ["Referrals", "Packages", "Broadcast"]],
  ["Website", ["Homepage", "Banners", "Locations"]],
  ["System", ["Staff", "Site Settings", "Integrations", "Data (Excel)", "Security"]],
];

export const AdminShell = ({ tabs, tab, setTab, badges = {}, children, settings }) => {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const pick = (t) => { setTab(t); setOpen(false); };
  const Nav = () => (
    <nav className="admin-nav" data-testid="admin-sidebar">
      {GROUPS.map(([g, items]) => {
        const vis = items.filter((t) => tabs.includes(t));
        if (!vis.length) return null;
        return <div key={g} className="admin-nav-group"><p className="admin-nav-label">{g}</p>
          {vis.map((t) => { const Icon = ICONS[t] || LayoutDashboard; const active = tab === t; return (
            <button key={t} data-testid={`admin-tab-${t.toLowerCase().replace(/[^a-z]/g, "-")}`} onClick={() => pick(t)} className={`admin-nav-item ${active ? "is-active" : ""}`}>
              <Icon className="w-4 h-4" /><span className="flex-1 text-left">{t}</span>
              {badges[t] > 0 && <span className="admin-nav-badge" data-testid={`admin-badge-${t.toLowerCase().replace(/[^a-z]/g, "-")}`}>{badges[t]}</span>}
            </button>); })}
        </div>;
      })}
    </nav>
  );
  return (
    <div className="admin-shell" data-testid="admin-shell">
      <aside className={`admin-aside ${open ? "is-open" : ""}`}>
        <div className="admin-aside-head"><Link to="/" className="flex items-center gap-2 text-white"><BrandLogo settings={settings} mobile testid="admin-brand" /></Link><button className="lg:hidden text-white" onClick={() => setOpen(false)} aria-label="Close menu"><X className="w-5 h-5" /></button></div>
        <div className="admin-user"><span className="admin-avatar">{(user?.name || "A").slice(0, 1).toUpperCase()}</span><div className="min-w-0"><p className="text-sm font-bold truncate text-white">{user?.name}</p><p className="text-[11px] text-white/60 truncate">{user?.is_super ? "Owner · Super Admin" : "Staff admin"}</p></div></div>
        <Nav />
        <button data-testid="admin-sidebar-logout" onClick={logout} className="admin-nav-item mt-auto text-red-200"><LogOut className="w-4 h-4" /> Logout</button>
      </aside>
      {open && <div className="admin-backdrop lg:hidden" onClick={() => setOpen(false)} />}
      <div className="admin-main">
        <header className="admin-topbar">
          <button data-testid="admin-menu-toggle" className="lg:hidden nb-btn nb-btn-sm" onClick={() => setOpen(true)}><Menu className="w-4 h-4" /></button>
          <div><p className="text-[11px] font-bold uppercase tracking-widest text-slate-400">Admin</p><h1 className="font-display text-xl sm:text-2xl font-extrabold tracking-tight" data-testid="admin-page-title">{tab}</h1></div>
          <div className="ml-auto hidden md:flex items-center gap-2 text-slate-400 text-sm bg-white border border-slate-200 rounded-full px-3 py-1.5 w-64"><Search className="w-4 h-4" /><span>Use the search in each section</span></div>
          <Link to="/" className="nb-btn nb-btn-sm hidden sm:inline-flex" data-testid="admin-view-site"><Bell className="w-4 h-4" /> View site</Link>
        </header>
        <main className="admin-content">{children}</main>
      </div>
    </div>
  );
};
